import { useSnackbar } from 'notistack';
import * as React from 'react';
import { Button } from 'components';
import { useAppSelector } from 'store/store';

const NOTIFICATION_SNACKBAR_KEY = 'app-notification';

export const useNotificationsHandler = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { notification } = useAppSelector((state) => state.notifications);

  React.useEffect(() => {
    if (!notification) {
      closeSnackbar(NOTIFICATION_SNACKBAR_KEY);
      return;
    }

    const hasButtons = !!(notification.buttonLeft || notification.buttonRight);
    const persist = notification.persist ?? hasButtons;

    enqueueSnackbar(notification.message, {
      key: NOTIFICATION_SNACKBAR_KEY,
      variant: notification.type,
      persist,
      style: notification.snackbarStyle,
      action:
        hasButtons && (notification.buttonLeft || notification.buttonRight)
          ? () => (
              <div style={{ display: 'flex', gap: '8px' }}>
                {notification.buttonLeft ? (
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => notification.buttonLeft?.onClick()}
                  >
                    {notification.buttonLeft.displayLabel}
                  </Button>
                ) : null}
                {notification.buttonRight ? (
                  <Button
                    variant="outlined"
                    size="small"
                    color="inherit"
                    onClick={() => notification.buttonRight?.onClick()}
                  >
                    {notification.buttonRight.displayLabel}
                  </Button>
                ) : null}
              </div>
            )
          : undefined,
    });
  }, [closeSnackbar, enqueueSnackbar, notification]);
};
